<div id="headerContainer" class="container-fluid sticky-top">
  <div class="row">
    <div class="col-md">
      <div class="row flex-nowrap">
        <div class="col justify-content-start d-flex align-items-center">
          <button mat-flat-button (click)="openMenu.emit('menu')" #menuButton>
            <mat-icon>menu</mat-icon>
            <span class="label d-none d-md-inline">{{ "COMPONENTS.HEADER.MENU" | translate }}</span>
          </button>
        </div>

        @if (ENV.MODULES.includes("CUSTOM_SPLIT_HEADER_LOGO")) {
          <div class="col d-flex justify-content-center">
            @for (logo of ENV.CUSTOM_HEADER_LOGOS; track logo) {
              @if (customLogoURLRoleCheck(logo.urls)) {
                @for (url of logo.urls; track url) {
                  @if (url.roles.includes(auth.roleName)) {
                    @if (url.urlType === "internal") {
                      <div
                        class="align-items-center img-fluid justify-content-center d-flex imageContainer"
                        style="cursor: pointer"
                        [routerLink]="url.url"
                        [matTooltip]="url.name ? ('COMPONENTS.HEADER.CUSTOM_TOOLTIP.' + url.name | translate) : url.name"
                      >
                        <img [src]="logo.imageRoute" alt="Logo" />
                      </div>
                    }
                    @if (url.urlType === "external") {
                      <a
                        class="align-items-center img-fluid justify-content-center d-flex imageContainer"
                        style="cursor: pointer"
                        [href]="url.url"
                        [matTooltip]="url.name ? ('COMPONENTS.HEADER.CUSTOM_TOOLTIP.' + url.name | translate) : url.name"
                      >
                        <img [src]="logo.imageRoute" alt="Logo" />
                      </a>
                    }
                  }
                }
              } @else {
                @for (url of logo.urls; track url) {
                  @if (url.default) {
                    @if (url.urlType === "internal") {
                      <div
                        class="align-items-center img-fluid justify-content-center d-flex imageContainer"
                        style="cursor: pointer"
                        [routerLink]="url.url"
                        [matTooltip]="url.name ? ('COMPONENTS.HEADER.CUSTOM_TOOLTIP.' + url.name | translate) : url.name"
                      >
                        <img [src]="logo.imageRoute" alt="Logo" />
                      </div>
                    }
                    @if (url.urlType === "external") {
                      <a
                        class="align-items-center img-fluid justify-content-center d-flex imageContainer"
                        style="cursor: pointer"
                        [href]="url.url"
                        [matTooltip]="url.name ? ('COMPONENTS.HEADER.CUSTOM_TOOLTIP.' + url.name | translate) : url.name"
                      >
                        <img [src]="logo.imageRoute" alt="Logo" />
                      </a>
                    }
                  }
                }
              }
            }
          </div>
        } @else {
          <div
            class="col align-items-center img-fluid justify-content-end d-flex imageContainer"
            style="cursor: pointer"
            [routerLink]="auth.roleName === 'resident' || auth.roleName === 'guest' || auth.roleName === 'coordinator' ? '/' : '/content'"
          >
            <img src="assets/organisation/images/logo.png" alt="Logo" />
          </div>
        }

        <div class="col justify-content-end d-flex align-items-center">
          <!-- <button class="bg-transparent" mat-flat-button routerLink="/faq">
            <span class="label d-none d-md-inline">{{ "COMPONENTS.HEADER.HELP" | translate }}</span>
            <mat-icon>help</mat-icon>
          </button> -->

          @if (auth.session | async) {
            <button mat-flat-button (click)="logout()">
              <span class="label d-none d-md-inline">{{ "COMPONENTS.HEADER.LOG_OUT" | translate }}</span>
              <mat-icon>logout</mat-icon>
            </button>
          } @else if(ENV.PORTAL_URL) {
            <button mat-flat-button (click)="auth.requestToken()">
              <span class="label d-none d-md-inline">{{ "COMPONENTS.HEADER.LOGIN" | translate }}</span>
              <mat-icon>login</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
